<template>
  <v-col class="pa-0">
    <x-org-heading heading="Domains"></x-org-heading>
    <h4 class="mt-2">
      Editing -
      {{ getSelectedDomain().data ? getSelectedDomain().data.domain : '' }}
    </h4>
    <DomainState
      :domainKey="$preference.INCOMING_IP_OR_DOMAIN_ADDRESS"
      :stateKey="'Incoming Address'"
    />
    <DomainState
      :domainKey="$preference.OUTGOING_IP_OR_DOMAINS_ADDRESS"
      :stateKey="'Outgoing Address'"
    />
  </v-col>
</template>

<script>
import DomainState from '@/components/Organisations/Domains/Domain/DomainState';
import { mapGetters } from 'vuex';
export default {
  components: { DomainState },
  methods: {
    ...mapGetters('domains', ['getSelectedDomain']),
  },
  watch: {
    currentlySelectedOrgId: function () {
      this.$router.push({
        path: '/email-gateway/domains',
      });
    },
  },
};
</script>

<style></style>
